import { DatasourceColumnCardinalityBackendModel, DatasourceColumnUIModel } from './datasource-column.model';

/**
 * @deprecated please adjust & use the `DatasourceTableUIModel` instead
 */
export class DatasourceTable {
  get fields(): DatasourceColumnUIModel[] {
    return this._fields;
  }

  set fields(fields: DatasourceColumnUIModel[]) {
    this._fields = fields;
  }

  get cardinality(): DatasourceColumnCardinalityBackendModel {
    return this._cardinality;
  }

  set cardinality(cardinality: DatasourceColumnCardinalityBackendModel) {
    this._cardinality = cardinality;
  }

  constructor(id: string, name: string) {
    this.id = id;
    this.name = name;
    this._fields = [];
  }
  public id: string;
  public name: string;
  private _fields!: DatasourceColumnUIModel[];
  private _cardinality!: DatasourceColumnCardinalityBackendModel;

  public rows?: unknown[];
}
